import { useSyncExternalStore } from 'react';

/**
 * Mobile breakpoint (px). At or below this width the chat shell switches to its
 * phone layout: off-canvas sidebar drawer + collapsed-by-default graph overlay
 * (see docs/spec/core/part3-ux-spec.md §6 and part2 req 577). Kept in sync with
 * the `@media (max-width: 768px)` rules in styles/globals.css.
 */
export const MOBILE_BREAKPOINT = 768;

const QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`;

function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(QUERY);
  // addEventListener('change') is the modern API; all target browsers support it.
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

// SSR / non-browser: default to desktop (false). The web client is a Vite SPA,
// but guarding keeps the hook safe in tests/jsdom without window.matchMedia.
function getServerSnapshot(): boolean {
  return false;
}

/**
 * Reactively reports whether the viewport is at mobile width. Re-renders the
 * caller when crossing the breakpoint (orientation change, resize, devtools).
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
